import { ReactNode } from 'react';
import Card from '@material-ui/core/Card';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

interface Props {
  className?: string;
  children: ReactNode;
}

export default function CardComponent({ className, children }: Props) {
  const classes = useStyles();
  return (
    <Card className={[classes.root, className].join(' ')}>
      {children}
    </Card>
  )
}

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    root: {
      minWidth: 275,
      maxWidth: 440,
      minHeight: 393,
      borderRadius: 20,
      margin: '0 20px 0 20px',
      display: 'flex',
      flexDirection: 'column',
      alignSelf: 'center',


      [theme.breakpoints.up('sm')]: {
        padding: '0rem 2em 1rem',
      }
    },
  },
  ));